import React from 'react'
import { ImportUsersBlock } from '../../../components/v2/import-users-block'

type Props = {
  officeId: number
  organizationId: number
  officeLabel?: string
  onImported: () => void
}

export function OfficeUsersImportButton({
  officeId,
  organizationId,
  officeLabel,
  onImported,
}: Props) {
  return (
    <ImportUsersBlock
      variant="modal"
      fixedOffice={{ officeId, organizationId }}
      fixedOfficeLabel={officeLabel}
      onImported={onImported}
    />
  )
}

export default OfficeUsersImportButton
